import * as JSCookie from 'js-cookie';

const defaultOptions = {
  // domain: 'localhost',
  // httpOnly: true,
  // path: '/',
  // sameSite: 'strict',
  secure: true,
};

const get = name => {
  return JSCookie.get(name);
};

const set = (name, value, options) => {
  const setOptions = Object.assign(defaultOptions, options);
  return JSCookie.set(name, value, setOptions);
};

const remove = (name, options) => {
  const removeOptions = Object.assign(defaultOptions, options);
  return JSCookie.remove(name, removeOptions);
};

const cookie = { get, set, remove };
export default cookie;
